export default "__VITE_ASSET__BMjrYh8o__"